import React from "react";
import { Section } from "../Section";
import { CTAButton } from "../CTAButton";
import { images } from "../../data/content";
const stops = ["Stop staring at a blank page.", "Stop rebuilding every class from scratch.", "Stop spending your evenings creating materials that should already have a structure."];
export function FinalCTA() {
  return <Section tone="cream" data-id="element-141" data-mp="3rqs94vbe21ys">
      <div className="text-center" data-id="element-142" data-mp="3dtc1xhl9q45z">
        <h2 className="font-serif text-[30px] font-bold leading-[1.15] tracking-tight text-ink md:text-5xl" data-id="element-143" data-mp="3dsapb8olt9m5">
          You already know how to create beautiful nails.{" "}
          <em className="text-berry" data-id="element-144" data-mp="33vph6ehafie3">Now build a teaching system that looks just as professional.</em>
        </h2>
        <ul className="mx-auto mt-8 max-w-xl space-y-2 text-[17px] text-muted" data-id="element-145" data-mp="38v20wqcv49cg">
          {stops.map(s => <li key={s} data-id="element-146" data-mp="124ufj60egozg">{s}</li>)}
        </ul>
        <p className="mt-6 text-[18px] font-semibold text-ink" data-id="element-147" data-mp="172dvcacqx9ti">
          You already have the knowledge. Now you need the vehicle to package it.
        </p>
        <img src={images.mockup} alt="Nail Course In A Box™ complete system" className="mx-auto mt-8 w-full max-w-2xl" data-id="element-148" data-mp="q6sohecr7pxj" />
      </div>
      <CTAButton label="Build my nail course in under 60 minutes" note="Only $27 · One-Time Payment · Instant Access · Lifetime Access · 7-Day Guarantee" data-id="element-149" data-mp="z0xha3bg7bfp" />
    </Section>;
}